module.exports = __webpack_public_path__ + "static/media/archive1639b5ae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/therapist/images/archive.svg
// module id = 671
// module chunks = 0